import React from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import { accentuate } from '../'
import { Section, Heading, Instructions, IconMessage, ExternalLink, ExternalLinkBlock } from '../s'
import Paragraph from 'components/typography/paragraph'
import { AlertTriangleFilled as Warning } from 'components/feather'

const VismadotnetHowToUse = ({ data }) => {
    const { formatMessage } = useIntl()

    return (
        <Section>
            <Heading>
                <FormattedMessage
                    id="integration_heading_how_to_use"
                    defaultMessage="How to use" />
            </Heading>
            <Paragraph>
                <FormattedMessage
                    id="integration_preamble_how_to_use"
                    defaultMessage="Get started quickly by following these steps:" />
            </Paragraph>
            <Instructions instructions={[
                {
                    text: formatMessage({
                        id: 'integration_visma.net_instruction_connect',
                        defaultMessage: 'To get started, you will need an <accent>Tenant ID</accent> provided by Visma.net Payroll. Read more about how to get it in our <link>knowledge base</link>'
                    }, {
                        accent: accentuate,
                        link: chunks => (
                            <ExternalLink href={data.knowledgebaseUrl}>
                                {chunks}
                            </ExternalLink>
                        )
                    })
                },
                {
                    text: formatMessage({
                        id: 'integration_visma.net_instruction_setup',
                        defaultMessage: 'Once you have the Tenant ID you can <accent>Set up</accent> the integration in Huma'
                    }, { accent: accentuate })
                },
                {
                    text: formatMessage({
                        id: 'integration_visma.net_instruction_accept_terms',
                        defaultMessage: 'Accept the terms and go through the integration settings'
                    })
                },
                {
                    text: formatMessage({
                        id: 'integration_visma.net_instruction_sync_users',
                        defaultMessage: 'To <accent>activate</accent> the integration you need to do an initial synchronization of users'
                    }, { accent: accentuate })
                }
            ]} />
            <IconMessage className="warning">
                <Warning size={20} />
                <div>
                    <Paragraph>
                        <FormattedMessage
                            id="integration_visma.net_disclaimer_changing_permissions"
                            defaultMessage="When changing the permissions associated with the <accent>Tenant ID<\/accent> in Visma.net Payroll’s settings, you will have to wait for up to 1 hour before the changes become available."
                            values={{ accent: accentuate }} />
                    </Paragraph>
                </div>
            </IconMessage>
            <ExternalLinkBlock href={data.knowledgebaseUrl}>
                <FormattedMessage
                    id="integration_visma.net_link_knowledgebase"
                    defaultMessage="Using the Visma.net Payroll integration" />
            </ExternalLinkBlock>
        </Section>
    )
}

export default VismadotnetHowToUse